var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#80A3ED",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0488 7.00195V13.3418H8.35547V7.00195H10.0488ZM8.25 5.34961C8.25 5.10352 8.33594 4.90039 8.50781 4.74023C8.67969 4.58008 8.91016 4.5 9.19922 4.5C9.48438 4.5 9.71289 4.58008 9.88477 4.74023C10.0605 4.90039 10.1484 5.10352 10.1484 5.34961C10.1484 5.5957 10.0605 5.79883 9.88477 5.95898C9.71289 6.11914 9.48438 6.19922 9.19922 6.19922C8.91016 6.19922 8.67969 6.11914 8.50781 5.95898C8.33594 5.79883 8.25 5.5957 8.25 5.34961Z",
    fill: "#80A3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallInfo);
export default __webpack_public_path__ + "static/media/small-info.cbb3547233c07aeff8af03ff9d552213.svg";
export { ForwardRef as ReactComponent };